var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.verificationShow,
          expression: "verificationShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c(
        "div",
        { staticClass: "content", attrs: { id: "twoStepverification" } },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\r\n                 " +
                _vm._s(_vm.$t("language.twoStepverification.bind")) +
                "\r\n                 "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePage()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step-body-content" }, [
            _c("div", { staticStyle: { float: "left", height: "60Px" } }, [
              _vm._v(
                "\r\n                " +
                  _vm._s(_vm.$t("language.twoStepverification.useAccount")) +
                  "\r\n                "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "step-footer" }, [
              _c(
                "button",
                {
                  staticClass: "step-bind",
                  on: {
                    click: function($event) {
                      return _vm.toBindEmail()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.personalCenter.bindEmail"))
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "step-cancel",
                  on: {
                    click: function($event) {
                      return _vm.cancelPage()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.twoStepverification.cancel")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3b685d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3b685d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/stepverification_bind_email_popup.vue
// module id = null
// module chunks = 